const sessionValues = new Map();

// Storage is optional: private browsing and blocked storage must remain playable.
export function readSaved(key, fallback = '') {
  try { return localStorage.getItem(key) ?? sessionValues.get(key) ?? fallback; } catch { return sessionValues.get(key) ?? fallback; }
}
export function save(key, value) {
  sessionValues.set(key, String(value));
  try { localStorage.setItem(key, String(value)); return true; } catch { return false; }
}
export function savedScore(key) {
  const score = Number(readSaved(key, '0'));
  return Number.isFinite(score) && score > 0 ? Math.floor(score) : 0;
}
